import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luFundingSourceType = {
  state: {
    luFundingSourceTypes: [],
    selectedLuFundingSourceType: {},
    selectedLuFundingSourceTypeOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luFundingSourceTypes(state) {
      return state.luFundingSourceTypes
    },
    selectedLuFundingSourceType(state) {
      return state.selectedLuFundingSourceType
    },
    selectedLuFundingSourceTypeOriginal(state) {
      return state.selectedLuFundingSourceTypeOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luFundingSourceTypes(state, payload) {
      state.luFundingSourceTypes = payload
    },
    selectedLuFundingSourceType(state, payload) {
      state.selectedLuFundingSourceType = JSON.parse(JSON.stringify(payload))
    },
    selectedLuFundingSourceTypeOriginal(state, payload) {
      state.selectedLuFundingSourceTypeOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuFundingSourceType(context, payload) {
      context.commit('selectedLuFundingSourceType', payload)
    },
    async loadLuFundingSourceTypes(context, payload) {
      const url = 'LuFundingSourceType'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luFundingSourceTypes', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedLuFundingSourceType(context, payload) {
      if (
        context.state.selectedLuFundingSourceType &&
        context.state.selectedLuFundingSourceType.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedLuFundingSourceType',
          context.state.selectedLuFundingSourceType.Id
        )
      }
    },
    async loadSelectedLuFundingSourceType(context, payload) {
      if (
        context.state.selectedLuFundingSourceType &&
        context.state.selectedLuFundingSourceType.Id != payload
      ) {
        context.commit('selectedLuFundingSourceType', {})
      }
      const url = 'LuFundingSourceType/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuFundingSourceType', res.data)
        context.commit('selectedLuFundingSourceTypeOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadLuFundingSourceTypes(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadLuFundingSourceTypes')
    },
    async createLuFundingSourceType(context, payload) {
      const url = `LuFundingSourceType`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source type created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSourceTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuFundingSourceType(context, payload) {
      var item = context.state.selectedLuFundingSourceType
      if (
        payload.Id &&
        payload.Id == context.state.selectedLuFundingSourceTypeOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuFundingSourceTypeOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuFundingSourceType/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'funding source type updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuFundingSourceTypes')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuFundingSourceType(context, payload) {
      const url = `LuFundingSourceType/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source type updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSourceTypes')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuFundingSourceType(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateLuFundingSourceType', payload)
      } else {
        return context.dispatch('createLuFundingSourceType', payload)
      }
    },
    async deleteLuFundingSourceType(context, payload) {
      const url = `LuFundingSourceType/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'funding source type deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuFundingSourceTypes')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luFundingSourceType
